import { useState } from "react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { PROJECT_FILTERS, IMAGES } from "@/data/content";
import { scrollToHash } from "@/components/Navbar";
import { cn } from "@/lib/utils";

export const Projects = () => {
    const [filter, setFilter] = useState("Residential");

    return (
        <section id="projects" data-testid="projects-section" className="relative overflow-hidden py-24 lg:py-36">
            <div className="absolute inset-0">
                <img src={IMAGES.projects} alt="" aria-hidden className="h-full w-full object-cover" loading="lazy" />
                <div className="blueprint absolute inset-0 bg-omsivo-deep/88" />
            </div>
            <div className="relative z-10 mx-auto max-w-[1440px] px-4 sm:px-6 lg:px-10">
                <SectionHeading
                    id="projects-heading"
                    dark
                    overline="Our Projects"
                    title={<>Built work, <span className="text-flame">published honestly.</span></>}
                    description="OMSIVO does not display fictional projects. Every project published here will be real, documented and verified — the portfolio opens soon."
                />

                <Reveal delay={0.15}>
                    <div className="mt-10 flex flex-wrap gap-2" role="tablist" aria-label="Project filters" data-testid="project-filters">
                        {PROJECT_FILTERS.map((f) => (
                            <button
                                key={f}
                                role="tab"
                                aria-selected={filter === f}
                                onClick={() => setFilter(f)}
                                data-testid={`project-filter-${f.toLowerCase().replace(/\s+/g, "-")}`}
                                className={cn(
                                    "rounded-full border px-4 py-2 font-mono text-[10px] uppercase tracking-[0.18em] transition-all",
                                    filter === f
                                        ? "border-flame bg-flame text-white"
                                        : "border-white/15 bg-white/5 text-white/60 hover:border-flame/60 hover:text-white"
                                )}
                            >
                                {f}
                            </button>
                        ))}
                    </div>
                </Reveal>

                <Reveal delay={0.22}>
                    <div className="mt-12 flex min-h-[280px] flex-col items-center justify-center rounded-[28px] border border-dashed border-white/20 bg-white/[0.03] px-6 py-16 text-center backdrop-blur-sm"
                        data-testid="projects-coming-soon">
                        <p className="text-outline-light font-display text-4xl font-black uppercase tracking-tight sm:text-6xl lg:text-7xl">
                            Coming Soon
                        </p>
                        <p className="mt-6 font-display text-lg font-bold uppercase tracking-[0.14em] text-white">
                            Project Portfolio — {filter}
                        </p>
                        <p className="mt-3 max-w-xl text-sm leading-relaxed text-white/60">
                            Real OMSIVO projects — residential, commercial, industrial, sheds, mega developments and interiors — will be showcased here with images, scope and status as they are documented.
                        </p>
                        <button
                            onClick={() => scrollToHash("#contact")}
                            data-testid="projects-discuss-btn"
                            className="mt-8 rounded-full bg-flame px-7 py-3.5 font-display text-sm font-bold uppercase tracking-[0.1em] text-white transition-all hover:-translate-y-0.5 hover:bg-flame-dark"
                        >
                            Start Your Project With OMSIVO
                        </button>
                    </div>
                </Reveal>
            </div>
        </section>
    );
};
